// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Events/';
export const EventActionTypes = {
  UPCOMING: ActionHelper.createActionTypes(actionTypePrefix, 'UPCOMING'),
  GALLERY: ActionHelper.createActionTypes(actionTypePrefix, 'GALLERY'),
  LATEST: ActionHelper.createActionTypes(actionTypePrefix, 'LATEST'),
  PAST: ActionHelper.createActionTypes(actionTypePrefix, 'PAST'),
  ALL: ActionHelper.createActionTypes(actionTypePrefix, 'ALL'),
  BANNER: ActionHelper.createActionTypes(actionTypePrefix, 'BANNER'),
  ARTISTS_GENRES: ActionHelper.createActionTypes(
    actionTypePrefix,
    'ARTISTS_GENRES'
  ),
  OVERLAY_DATA: ActionHelper.createActionTypes(
    actionTypePrefix,
    'OVERLAY_DATA'
  ),
  EVENT_ARTIST_DETAILS: {
    FETCH: `${actionTypePrefix}/EVENT_ARTIST_DETAILS_FETCH`,
  },
  PAST_EVENT_FILTERS: {
    INITIALIZE: `${actionTypePrefix}/EVENT_FILTERS_INITIALIZE`,
    TOGGLE_FILTER: `${actionTypePrefix}/EVENT_FILTERS_TOGGLE_FILTER`,
    CLEAR_FILTERS: `${actionTypePrefix}/EVENT_FILTERS_CLEAR_FILTERS`,
  },
  UPCOMING_EVENT_FILTERS: {
    INITIALIZE: `${actionTypePrefix}/UPCOMING_EVENT_FILTERS_INITIALIZE`,
    TOGGLE_FILTER: `${actionTypePrefix}/UPCOMING_EVENT_FILTERS_TOGGLE_FILTER`,
    CLEAR_FILTERS: `${actionTypePrefix}/UPCOMING_EVENT_FILTERS_CLEAR_FILTERS`,
  },
  EVENT_TICKETS: {
    STANDING: `${actionTypePrefix}/EVENT_TICKETS_STANDING`,
    TABLE_BOOKING: `${actionTypePrefix}/EVENT_TICKETS_TABLE_BOOKING`,
  },
  OUTLET_SEATING: ActionHelper.createActionTypes(
    actionTypePrefix,
    'OUTLET_SEATING'
  ),
  EVENT_STANDING_CAPACITY_STATUS: ActionHelper.createActionTypes(
    actionTypePrefix,
    'EVENT_STANDING_CAPACITY_STATUS'
  ),
  EVENT_BOOKED_TABLES: ActionHelper.createActionTypes(
    actionTypePrefix,
    'EVENT_BOOKED_TABLES'
  ),
};
